import { type FC } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogDeliveryInformationProps extends Omit<DialogProps, 'children'> {
  countKs: number
  countGuru: number
  onClickConfirm: () => void
  onClickCancel: () => void
}

const DialogDeliveryInformation: FC<DialogDeliveryInformationProps> = ({
  countKs,
  countGuru,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  ...props
}) => {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6 space-y-4">
          <Text variant="display-sm">
            Pengiriman data Kepala Sekolah dan Guru
          </Text>

          <Text variant="body-lg" color="subdued">
            Berikut rincian data yang akan dikirim:
          </Text>

          <div className="border border-subdued rounded bg-surface-subdued px-4 py-3 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <Text variant="body" className="text-gray-90">
                Kepala Sekolah
              </Text>
              <Text variant="subheading" color="subdued" className="uppercase">
                {countKs || 0} Orang
              </Text>
            </div>
            <div className="flex items-center justify-between">
              <Text variant="body" className="text-gray-90">
                Guru
              </Text>
              <Text variant="subheading" color="subdued" className="uppercase">
                {countGuru || 0} Orang
              </Text>
            </div>
          </div>

          <div className="flex gap-5 !mt-6">
            <Button
              size="lg"
              color="white"
              onClick={onClickCancel}
              data-testid="btn-cancel"
            >
              Kembali
            </Button>
            <Button
              size="lg"
              onClick={onClickConfirm}
              data-testid="btn-confirm"
            >
              Saya mengerti
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogDeliveryInformation
